import { ResultSet } from "@cubejs-client/core";
import { immerable } from "immer";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export const loadRegions = (): AppThunk<Promise<Region[]>> => async (dispatch) => {
    try {
        const query = {
            filters: [{
                "member": "D_Store.k_Region",
                "operator": "set",
            }],
            dimensions: ["D_Store.k_Region"]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        return resultSet.rawData().map(row => new Region(
            row["D_Store.k_Region"]
        ));
    } catch (error) {
        dispatch(logError("Error loading Regions.", error));
        throw error;
    }
};

export class Region {
    public readonly name: string;

    constructor(
        name: string
    ) {
        this.name = name;
    }
}


export class RegionMultiSelect extends Region {
    [immerable] = true;

    private _isSelected: boolean;

    constructor(
        storeGroup: Region,
        _isSelected: boolean
    ) {
        super(
            storeGroup.name
        );
        this._isSelected = _isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }
}
